/**
 * 地図の getters
 */
const getters = {
};

export { getters as default };
